import { render, staticRenderFns } from "./PrimaryText.vue?vue&type=template&id=c58f6416&scoped=true&"
import script from "./PrimaryText.vue?vue&type=script&lang=ts&"
export * from "./PrimaryText.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryText.vue?vue&type=style&index=0&id=c58f6416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58f6416",
  null
  
)

export default component.exports